import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { lowcode } from '..';
let AmImageMixin = class AmImageMixin extends Vue {
  get style() {
    return {
      width: this.autoWidth ? 'auto' : this.width ? `${this.width}px` : undefined,
      height: this.autoHeight ? 'auto' : this.height ? `${this.height}px` : undefined,
      borderRadius: this.borderRadius
    };
  }
};
__decorate([Prop({
  default: () => {
    return lowcode.utils.url2cdn('amupload/static/component_img.png');
  }
})], AmImageMixin.prototype, "src", void 0);
__decorate([Prop()], AmImageMixin.prototype, "fit", void 0);
__decorate([Prop({
  default: '350'
})], AmImageMixin.prototype, "width", void 0);
__decorate([Prop({
  default: false
})], AmImageMixin.prototype, "autoWidth", void 0);
__decorate([Prop({
  default: '200'
})], AmImageMixin.prototype, "height", void 0);
__decorate([Prop({
  default: false
})], AmImageMixin.prototype, "autoHeight", void 0);
__decorate([Prop()], AmImageMixin.prototype, "borderRadius", void 0);
__decorate([Prop()], AmImageMixin.prototype, "title", void 0);
__decorate([Prop({
  default: 'Image 404'
})], AmImageMixin.prototype, "alt", void 0);
__decorate([Prop({
  default: false
})], AmImageMixin.prototype, "lazy", void 0);
__decorate([Prop()], AmImageMixin.prototype, "dataId", void 0);
AmImageMixin = __decorate([Component({
  name: 'AmImageMixin'
})], AmImageMixin);
export default AmImageMixin;